/**
 * Main Menu object
 */
var MainMenu = (function () {

    var menuWrapper,
        burgerIcon,
        menu,
        menuItems,
        searchBar;

	var init = function() {

        menuWrapper = $('.site-header__menu');
        burgerIcon = menuWrapper.find('.dropdown-toggle');
        menu = menuWrapper.find('.primary-menu');
        menuItems = $(menu[0]).children(); // items desktop menu
        searchBar = menuWrapper.find('.search-container');

        // Open/Close menu
        burgerIcon.bind('touch click', function(e) {
            if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                $('html, body').toggleClass('overflow');
            }
            if($(this).hasClass('active')) {
                closeMenu();
                searchBar.removeClass('active');
            } else {
                openMenu();
            }
            $(document).trigger('click');
            return false;
        });

        // Search bar
        searchBar.bind('touch click', function() {
            $(this).addClass('active');
        });

        // Close menu when click outside
        $('html').on('click',function() {
            closeMenu();
            searchBar.removeClass('active');
        });
	};

    /*** Functions ****/
    var openMenu = function() {
        burgerIcon.addClass('active');
        menu.addClass('open');
        $('.site-header').addClass('open');
        console.log('menu height !', menu, menu.children('.inner'), menu.children('.inner').outerHeight())
        menu.css('height', menu.children('.inner').outerHeight())
    };
    var closeMenu = function() {
        burgerIcon.removeClass('active');
        menu.removeClass('open');
        $('.site-header').removeClass('open');
        menu.css('height', 0);
    };
    return {
        init: init
    };

})();

$(document).ready(function() {
    MainMenu.init();
});
